import React from "react";
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

const DocumentationField = ({ formData = {}, onChange, idSchema, errorSchema = {} }) => {
  const handleChange = (field) => (event) => {
    const newData = {
      ...formData,
      [field]: field === "dnrLocation" ? event.target.value : event.target.checked,
    };

    // Clear DNR location if DNR is unchecked
    if (field === "documentDNR" && !event.target.checked) {
      newData.dnrLocation = "";
    }

    onChange(newData);
  };

  const dnrLocation =
    errorSchema?.dnrLocation?.__errors?.length > 0
      ? errorSchema.dnrLocation.__errors[0]
      : null;


  return (
    <>
      <Box
        sx={{
          border: "1px solid #ccc",
          borderRadius: 2,
          padding: 2,
          mt: 2,
        }}
      >
        <Box display="flex" alignItems="center" mb={2}>
          <InfoIcon sx={{ mr: 1 }} />
          <Typography variant="body2">
            The following documents may be provided to Cambridge Caregivers. Please select all that apply.
          </Typography>
        </Box>

        <FormControlLabel sx={{ mb: 1 }}
          slotProps={{
            typography: {
              lineHeight: 1
            }
          }}
          control={
            <Checkbox
              checked={formData.documentMPOA || false}
              onChange={handleChange("documentMPOA")}
            />
          }
          label={
            <>
              <Typography variant="h6">
                Medical Power of Attorney (MPOA)
              </Typography>
              <Typography variant="body2" color="default.light">
                Client must provide a copy of MPOA to Cambridge Caregivers at Assessment on or before the first shift.
              </Typography>
            </>
          }
        />

        <FormControlLabel
          slotProps={{
            typography: {
              lineHeight: 1
            }
          }}
          control={
            <Checkbox
              checked={formData.documentDNR || false}
              onChange={handleChange("documentDNR")}
            />
          }
          label={
            <>
              <Typography variant="h6">
                OOH DNR (Do Not Resuscitate)
              </Typography>
            </>
          }
        />

        {formData.documentDNR && (
          <Box mt={2}>
            <TextField
              fullWidth
              label="Enter Location of Document"
              value={formData.dnrLocation || ""}
              onChange={handleChange("dnrLocation")}
              error={!!dnrLocation}
              helperText={dnrLocation || ""}
            />
            <Typography variant="caption" sx={{ mt: 1, display: "block" }}>
              *If location not provided, client must notify Cambridge Caregivers of location in home on or before the first shift.
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
};

export default DocumentationField;
 